// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useState } from "react";
import { Col, Form, Row } from "antd";
import { TwitterPicker } from "react-color";
import { ThematicDossierColorFormProps } from "../../../types/ThematicDossierTypes";
import { useTranslation } from "react-i18next";

const ThematicDossierColorFormSection: React.FunctionComponent<ThematicDossierColorFormProps> = (
  props: ThematicDossierColorFormProps
) => {
  const { t } = useTranslation();

  const { color, setColor, editMode = true } = props;

  const [displayColorPicker, setDisplayColorPicker] = useState<boolean>(false);

  const colors: string[] = [
    "#efce2f",
    "#e1cc9f",
    "#ef785c",
    "#f2928f",
    "#a3bfb5",
    "#7b97b6",
    "#b7991d",
    "#a38968",
    "#c53b2e",
    "#d15258",
    "#489379"
  ];

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChangeComplete = (colorObj: any) => {
    setColor(colorObj.hex);
    setDisplayColorPicker(!displayColorPicker);
  };

  return (
    <>
      <Row>
        <Col xs={24} className="position-relative">
          <Form.Item
            name="keywords"
            key="keywords"
            label={<span>{t("thematic_dossier.color")}</span>}
          >
            <div
              className={`color-picker-custom-container ${
                !editMode ? "disabled" : ""
              } ${displayColorPicker ? "open" : ""}`}
              onClick={editMode ? handleClick : undefined}
            >
              <div
                className="color-picker-custom-color"
                style={{ backgroundColor: color }}
              />
            </div>
            {displayColorPicker && (
              <div className="color-picker-custom-popover">
                <div
                  className="color-picker-custom-cover"
                  onClick={handleClose}
                />
                <TwitterPicker
                  onChangeComplete={handleChangeComplete}
                  triangle="hide"
                  width="256px"
                  color={color}
                  colors={colors}
                />
              </div>
            )}
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default ThematicDossierColorFormSection;
